/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import AdvertisersApi from '@/services/advertisers';

const state = {
  advertisers: [],
  advertisersLinks: {},
  advertisersDetails: {},
  pageAdvertiserCustom: [],
  pageAdvertiser: undefined,
  campaign: undefined,
  urlCloudfrontCreative: undefined,
};

const getters = {
  allAdvertisers: currentState => currentState.advertisers,
  activeAdvertisers: currentState => currentState.advertisers
    .filter(advertiser => advertiser.is_active),
  allAdvertiserLinks: currentState => currentState.advertisersLinks,
  allAdvertisersDetails: currentState => currentState.advertisersDetails,
  pageAdvertiserCustom: currentState => currentState.pageAdvertiserCustom,
  pageAdvertiser: currentState => currentState.pageAdvertiser,
  getCampaign: currentState => currentState.campaign,
  getUrlCloudfrontCreative: currentState => currentState.urlCloudfrontCreative,
};

const actions = {
  async fetchAdvertisers({ commit, state }) {
    let { advertisers = [] } = state;
    advertisers = await AdvertisersApi.getAdvertisers();
    commit('setAdvertisers', advertisers);
  },
  async fetchAdvertiserLinks({ commit, state }, advertiserCode) {
    const { advertisersLinks = {} } = state;

    const advertiser = await AdvertisersApi.getAdvertiserLinksOnly(advertiserCode);
    advertiser.code = advertiserCode;
    advertisersLinks[advertiserCode] = advertiser;

    commit('setAdvertisersLinks', advertisersLinks);
  },
  async fetchAdvertiser({ commit, state }, advertiserCode) {
    const { advertisersDetails = {}, advertisersLinks = {} } = state;
    const advertiser = await AdvertisersApi.getAdvertiser(advertiserCode);
    const advertisersCustomDetails = (advertiser.id === 141 || advertiser.id === 190) ? await AdvertisersApi.getAdvertiserCustomInformation(advertiser.id) : [];
    advertiser.code = advertiserCode;
    advertisersDetails[advertiserCode] = advertiser;
    advertisersLinks[advertiserCode] = advertiser;

    commit('setAdvertisersDetails', advertisersDetails);
    commit('setPageAdvertiserCustom', advertisersCustomDetails);
    commit('setAdvertisersLinks', advertisersLinks);
    commit('setPageAdvertiser', advertiser);
  },
  async setPageAdvertiserByCode({ commit, state }, advertiserCode) {
    try {
      await actions.fetchAdvertiser({ commit, state }, advertiserCode);
      const advertiser = state.advertisersDetails[advertiserCode];
      commit('setPageAdvertiser', advertiser);
    } catch (error) {
      throw error;
    }
  },
  async setCampaign({ commit }, campaign) {
    commit('setCampaign', campaign);
  },
  async fetchAdvertisersUrlCloudfrontCreative({ commit }) {
    const urlCloudfrontCreative = await AdvertisersApi.getAdvertisersUrlCloudfrontCreative();
    commit('setUrlCloudfrontCreative', urlCloudfrontCreative);
  },
};

const mutations = {
  setAdvertisers: (currentState, advertisers) => {
    currentState.advertisers = advertisers;
  },
  setAdvertisersLinks: (currentState, advertisersLinks) => {
    currentState.advertisersLinks = advertisersLinks;
  },
  setAdvertisersDetails: (currentState, advertisersDetails) => {
    currentState.advertisersDetails = advertisersDetails;
  },
  setPageAdvertiser: (currentState, advertiser) => {
    currentState.pageAdvertiser = advertiser;
  },
  setPageAdvertiserCustom: (currentState, advertisersCustomDetails) => {
    currentState.pageAdvertiserCustom = advertisersCustomDetails;
  },
  setCampaign: (currentState, campaign) => {
    currentState.campaign = campaign;
  },
  setUrlCloudfrontCreative: (currentState, urlCloudfrontCreative) => {
    currentState.urlCloudfrontCreative = urlCloudfrontCreative;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
